import React, { useEffect, ReactNode } from 'react';
import styles from './PublicPage.module.scss';
import FooterV2 from 'legacy/common/components/footer-v2/FooterV2';
import { useIntercom } from 'features/intercom/context/IntercomProvider';

interface PublicPageProps {
  children: ReactNode;
  showFooter?: boolean;
}

export default function PublicPage({ children, showFooter }: PublicPageProps) {
  const { setHideIntercom } = useIntercom();

  useEffect(() => {
    setHideIntercom(true);

    return () => {
      setHideIntercom(false);
    };
  }, [setHideIntercom]);

  return (
    <div className={styles.PublicPage}>
      {children}
      {showFooter && <FooterV2 />}
    </div>
  );
}
